var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M16 9.13208H9.15862V16H6.84138V9.13208H0V6.90566H6.84138V0H9.15862V6.90566H16V9.13208Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }